"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _CountrySelect = _interopRequireDefault(require("ui-addon-i18n/components/CountrySelect"));

var FilterCountrySelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterCountrySelect, _PureComponent);
  (0, _createClass2.default)(FilterCountrySelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        value: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.instanceOf(_immutable.List)])
      };
    }
  }]);

  function FilterCountrySelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterCountrySelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterCountrySelect).call(this, props));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterCountrySelect, [{
    key: "validateInput",
    value: function validateInput(value) {
      var size = _immutable.List.isList(value) ? value.size : value.length;
      this.setState({
        isInputValid: Boolean(size)
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.props.onBlur();
      this.validateInput(this.props.value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      this.props.onChange(e);
      this.validateInput(value);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.props.value;
      var valueArray = _immutable.List.isList(value) ? value.toJS() : value;
      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input long"
      }, _react.default.createElement(_CountrySelect.default, {
        error: !this.state.isInputValid,
        multi: true,
        value: valueArray,
        onBlur: this.handleBlur,
        onChange: this.handleChange
      }));
    }
  }]);
  return FilterCountrySelect;
}(_react.PureComponent);

exports.default = FilterCountrySelect;
module.exports = exports.default;